/**
 * Shared marketing copy for landing, SEO JSON-LD, llms.txt, and answer engines.
 * Keep answers concise and factual — optimized for AEO / GEO citation.
 */

export const SITE_FAQ = [
  {
    q: "What is Zoniq EventOS?",
    a: "A single workspace for event teams to plan events, track finances, run live ticket operations, and generate GST invoices, built to replace the spreadsheet-and-WhatsApp stack most teams run on today.",
  },
  {
    q: "Who is Zoniq EventOS for?",
    a: "Event agencies, festival promoters, venue operators, artist managers, and corporate event teams who are tired of chasing numbers and updates across five different tools.",
  },
  {
    q: "What features does Zoniq EventOS include?",
    a: "Event dashboards and P&L tracking, live ticket entry logging, logistics and task planning, GST-ready tax invoices with event-based numbering, and CSV export for finance teams.",
  },
  {
    q: "Does Zoniq EventOS support GST invoicing in India?",
    a: "Yes, teams can generate GST tax invoices with buyer/seller/consignee details, HSN/SAC line items, bank details, and PDF exports under their own business brand.",
  },
  {
    q: "How do I get access?",
    a: "We're onboarding a small group of founding teams directly right now, with hands-on setup from the founders. Book a call to see if it's a fit — self-serve signup isn't open yet.",
  },
  {
    q: "What do founding teams get?",
    a: "Direct founder-led onboarding, priority input into the roadmap, and early access as new features ship — we're building this closely with the first teams who use it.",
  },
] as const;

export const SITE_OUTCOMES = [
  "Track event profitability in real-time",
  "Centralize event operations",
  "Eliminate spreadsheet chaos",
  "Generate GST-ready invoices",
  "Monitor live ticket performance",
] as const;

export const SITE_AUDIENCES = [
  "Event agencies managing multiple productions",
  "Festival promoters tracking ticket sales and live ops",
  "Venue operators monitoring event performance",
  "Artist managers coordinating tours and logistics",
  "Corporate event teams replacing spreadsheet workflows",
] as const;
